import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { CleverPushService } from '@zero/feature-clever-push/base';
import { AuthStateFacade } from '@zero/shared/util-global-state';
import { SourcePointService } from '@zero/shared/util-source-point';
import { RouteOptionsService } from '@zero/shared/util-web-app-services';
import { URL_APPSTORE_APPLE, URL_APPSTORE_GOOGLE, commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'web-components-footer',
  templateUrl: './footer.component.html',
  imports: [TranslocoPipe, RouterLink, AsyncPipe],
})
export class FooterComponent implements OnInit {
  public isVisible = true;
  public readonly commonRoutes = commonRoutes;
  public readonly URL_APPSTORE_APPLE = URL_APPSTORE_APPLE;
  public readonly URL_APPSTORE_GOOGLE = URL_APPSTORE_GOOGLE;
  public readonly landingPage = 'https://www.finanzen.net/zero';

  public readonly sourcePointService = inject(SourcePointService);
  public readonly authStateFacade = inject(AuthStateFacade);
  readonly #routeOptionsService = inject(RouteOptionsService);
  readonly #cleverPushService = inject(CleverPushService);

  #clickCount = 0;

  ngOnInit(): void {
    this.#routeOptionsService.routeOptions$.subscribe((options) => {
      this.isVisible = !options?.shouldHideHeaderAndFooter;
    });
  }

  public async cleverPushFeatureClick() {
    if (this.#clickCount === 5) {
      return;
    }

    this.#clickCount++;
    if (this.#clickCount === 5) {
      try {
        const isEnabled = await this.#cleverPushService.isFeatureEnabled();
        if (isEnabled) {
          return;
        }

        await this.#cleverPushService.enableFeature();
        window.location.reload();
      } catch (error) {
        console.error('error', error);
      }
    }
  }
}
